import React from "react";
import PropTypes from "prop-types";

import styles from "./FormContainer.module.scss";

const FormCardBody = ({
  children,
  footer,
  compact = false,
  className = "",
  style,
}) => {
  const body = (
    <>
      <div className={styles.formCardBodyContent}>{children}</div>
      {footer ? (
        <div className={`oui-text-center ${styles.formCardBodyFooter}`}>
          {footer}
        </div>
      ) : null}
    </>
  );

  if (compact) {
    return (
      <div className={`${styles.formCardBody} ${className}`} style={style}>
        {body}
      </div>
    );
  }

  return (
    <div
      className={`oui-card-body oui-mx-3 ${styles.formCardBody} ${className}`}
      style={style}
    >
      {body}
    </div>
  );
};

FormCardBody.propTypes = {
  children: PropTypes.node.isRequired,
  footer: PropTypes.node,
  compact: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default FormCardBody;
